/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./PrimaryToolbarComponent.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import PinIcon from '@atlaskit/icon/core/pin';
import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
import { fg } from '@atlaskit/platform-feature-flags';
var buttonStyles = null;
/**
 * A component used to renderer a pin/unpin
 * button to the toolbar to the or make it in-line.
 */
export var PrimaryToolbarComponent = function PrimaryToolbarComponent(_ref) {
  var _api$userPreferences, _api$selectionToolbar;
  var api = _ref.api,
    disabled = _ref.disabled;
  var intl = useIntl();
  var mode = useSharedPluginStateSelector(api, 'connectivity.mode');
  var isOffline = mode === 'offline' || false;
  var isDockedToTop = fg('platform_editor_use_preferences_plugin') ? (api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.preferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.toolbarDockingPosition) === 'top' : (api === null || api === void 0 || (_api$selectionToolbar = api.selectionToolbar.sharedState.currentState()) === null || _api$selectionToolbar === void 0 ? void 0 : _api$selectionToolbar.toolbarDocking) === 'top';
  if (isDockedToTop) {
    return /*#__PURE__*/React.createElement(ToolbarButton, {
      "aria-label": intl.formatMessage(selectionToolbarMessages.toolbarPositionPinedAtTop)
      // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
      ,

      disabled: disabled || isOffline,
      iconBefore: /*#__PURE__*/React.createElement(PinFilledIcon, {
        label: "",
        spacing: "spacious"
      }),
      onClick: function onClick() {
        var _api$selectionToolbar2, _api$selectionToolbar3, _api$selectionToolbar4;
        if (fg('platform_editor_migrate_toolbar_docking')) {
          var _api$core$actions$exe, _api$userPreferences2;
          return (_api$core$actions$exe = api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences2 = api.userPreferences) === null || _api$userPreferences2 === void 0 ? void 0 : _api$userPreferences2.actions.updateUserPreference('toolbarDockingPosition', 'none'))) !== null && _api$core$actions$exe !== void 0 ? _api$core$actions$exe : false;
        }
        return (_api$selectionToolbar2 = api === null || api === void 0 || (_api$selectionToolbar3 = api.selectionToolbar.actions) === null || _api$selectionToolbar3 === void 0 || (_api$selectionToolbar4 = _api$selectionToolbar3.setToolbarDocking) === null || _api$selectionToolbar4 === void 0 ? void 0 : _api$selectionToolbar4.call(_api$selectionToolbar3, 'none')) !== null && _api$selectionToolbar2 !== void 0 ? _api$selectionToolbar2 : false;
      },
      title: intl.formatMessage(selectionToolbarMessages.toolbarPositionPinedAtTop),
      className: ax(["_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"])
    });
  }
  return /*#__PURE__*/React.createElement(ToolbarButton, {
    "aria-label": intl.formatMessage(selectionToolbarMessages.toolbarPositionUnpined)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
    ,

    disabled: disabled || isOffline,
    iconBefore: /*#__PURE__*/React.createElement(PinIcon, {
      label: "",
      spacing: "spacious"
    }),
    onClick: function onClick() {
      var _api$selectionToolbar5, _api$selectionToolbar6, _api$selectionToolbar7;
      if (fg('platform_editor_migrate_toolbar_docking')) {
        var _api$core$actions$exe2, _api$userPreferences3;
        return (_api$core$actions$exe2 = api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences3 = api.userPreferences) === null || _api$userPreferences3 === void 0 ? void 0 : _api$userPreferences3.actions.updateUserPreference('toolbarDockingPosition', 'top'))) !== null && _api$core$actions$exe2 !== void 0 ? _api$core$actions$exe2 : false;
      }
      return (_api$selectionToolbar5 = api === null || api === void 0 || (_api$selectionToolbar6 = api.selectionToolbar.actions) === null || _api$selectionToolbar6 === void 0 || (_api$selectionToolbar7 = _api$selectionToolbar6.setToolbarDocking) === null || _api$selectionToolbar7 === void 0 ? void 0 : _api$selectionToolbar7.call(_api$selectionToolbar6, 'top')) !== null && _api$selectionToolbar5 !== void 0 ? _api$selectionToolbar5 : false;
    },
    title: intl.formatMessage(selectionToolbarMessages.toolbarPositionUnpined),
    className: ax(["_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"])
  });
};